import Router from 'components/routes/routers/simulation/scpi/ScpiSimulationRouter';
import Creation, { formValidate, initialValues } from './Creation';

const scpi = {
    // human readable title for this kind of product
    label: 'SCPI',
    // it may have additional fields (the RIP is given as property)
    formComponent: Creation,
    // it may have to validate data (must be a validator signature)
    formValidate: (errors, values, props) => formValidate(values, props, errors),
    // it may have initial values
    initialValues,
    // and an entry point for the form
    router: Router,
    entryPoint: 'overview',
};

export default scpi;
